import React, { useContext } from "react";
import { Space, PageHeader, Form, Switch, Alert, Button } from "antd";
import { CloseOutlined, CheckOutlined } from "@ant-design/icons";

import { GlobalContext } from "../GlobalContext";
import defaultMods from "../../data/defaults/mods.json";

const Mods = () => {
    const { userData, setMods } = useContext(GlobalContext);
    let { mods } = userData;
    let noModsFile = false;

    if (!mods) {
        noModsFile = true;
        mods = defaultMods;
    }

    const saveDefaultMods = () => {
        setMods(defaultMods);
    };

    const handleOnChange = (changedFields) => {
        let modsObject = {
            ...mods,
        };

        changedFields.forEach((field) => {
            let name = field.name[0];
            let value = field.value === true ? true : false;

            if (name === "enableTimer") {
                if (value === true) {
                    value = false;
                } else {
                    value = true;
                }
            }

            modsObject[name] = value;
        });

        setMods(modsObject);
    };

    return (
        <Space direction="vertical" size="middle" style={{ display: "flex" }}>
            <PageHeader className="site-page-header" title="Mods" />

            <Form
                name="mods"
                labelCol={{ span: 7 }}
                labelAlign="left"
                wrapperCol={{ span: 12 }}
                onFieldsChange={handleOnChange}
                autoComplete="off"
                style={{
                    padding: `16px 24px`,
                }}
            >
                {noModsFile ? (
                    <Alert
                        message="No mods.json file was found, so the defaults were loaded instead."
                        type="warning"
                        showIcon
                        style={{
                            marginBottom: `24px`,
                        }}
                        action={
                            <Button
                                onClick={saveDefaultMods}
                                size="small"
                                type="primary"
                            >
                                Save defaults
                            </Button>
                        }
                    />
                ) : null}
                <Form.Item
                    label="Disable timer"
                    name="enableTimer"
                    tooltip="Disables the timer on the character and song select screens."
                >
                    <Switch
                        checkedChildren={<CheckOutlined />}
                        unCheckedChildren={<CloseOutlined />}
                        checked={mods.enableTimer ? false : true}
                    />
                </Form.Item>

                <Form.Item
                    label="Enable Dani Dojo"
                    name="enableDaniMode"
                    tooltip="This mode will not work without server data and will crash after the initial cutscene."
                >
                    <Switch
                        checkedChildren={<CheckOutlined />}
                        unCheckedChildren={<CloseOutlined />}
                        checked={mods.enableDaniMode}
                    />
                </Form.Item>

                <Form.Item
                    label="Enable AI Battle Mode"
                    name="enableAiBattleMode"
                >
                    <Switch
                        checkedChildren={<CheckOutlined />}
                        unCheckedChildren={<CloseOutlined />}
                        checked={mods.enableAiBattleMode}
                    />
                </Form.Item>

                <Form.Item
                    label="Skip AI Battle Story Cutscene"
                    name="skipAiBattleStory"
                >
                    <Switch
                        checkedChildren={<CheckOutlined />}
                        unCheckedChildren={<CloseOutlined />}
                        checked={mods.skipAiBattleStory}
                    />
                </Form.Item>

                <Form.Item
                    label="Skip AI Battle Tutorial Cutscene"
                    name="skipAiBattleTutorial"
                >
                    <Switch
                        checkedChildren={<CheckOutlined />}
                        unCheckedChildren={<CloseOutlined />}
                        checked={mods.skipAiBattleTutorial}
                    />
                </Form.Item>
            </Form>
        </Space>
    );
};

export default Mods;
